import { ReactElement } from "react";
import { joinUsers } from "../../types/Reievespf001";

interface joinUsersModalProps{
    users: joinUsers[];
    onClick: () => void;
}


/**
 * 参加予定の会員モーダルのコンポーネント
 * @returns 
 */
export function JoinUsersList(props: joinUsersModalProps): ReactElement{

    return(
        <>
            <div className="overlay-box">
                <div className="modal-box">
                    <div className="modal-base">
                        <div className="mdl-wrap">
                            <button 
                                className="mdl-close-btn"
                                onClick={props.onClick}
                            />

                            <div className="mdl-cont">
                                <div className="mdl-ttl">
                                    参加予定の会員
                                </div>
                                {props.users.length === 0 ?
                                    <div className="mdl-scr-box">
                                        <div className="list-view">
                                            <dl>現在参加予定の会員はいません。</dl>
                                        </div>
                                    </div>
                                    :
                                    <div className="mdl-scr-box">
                                        <div className="list-view">
                                            {props.users.map((user, index) => (
                                                <dl key={index}>
                                                    <dt className="no">{index + 1}</dt>
                                                    <dd>{user.name}様</dd>
                                                </dl>
                                            ))}
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="overlay-bg" />
        </>
        
    );

}